export default __webpack_public_path__ + "static/media/IMG_2333.8966de17.jpg";